import { dmsActions, useDmsDispatch, useDmsState } from '@packages/contexts/dms';
import Loader from '@web/components/loader';
import { dmsService } from '@web/services/singletons';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from './layout';
import { DMSDetailContent } from './dms-detail-content';
import NoMatch from '@web/views/no-match';

export const DmsDetail = () => {
    const { vin: vinString, repairOrder } = useParams<{ vin: string; repairOrder?: string }>();
    const { loading, repairOrdersHistory, hasHistoryFetched, selectedRepairOrder } = useDmsState();
    const dispatch = useDmsDispatch();

    useEffect(() => {
        if (vinString && !hasHistoryFetched) {
            dmsService.fetchAndSetRepairOrderHistory(vinString, dispatch);
        }
    }, [vinString, hasHistoryFetched, dispatch]);

    useEffect(() => {
        if (hasHistoryFetched && repairOrdersHistory.length > 0 && repairOrder) {
            const foundOrder = repairOrdersHistory.find((order) => order.roNumber === repairOrder) ?? null;
            dispatch(dmsActions.setSelectedOrder({ selectedOrder: foundOrder }));
        }
    }, [hasHistoryFetched, repairOrdersHistory, repairOrder, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(dmsActions.setSelectedOrder({ selectedOrder: null }));
        };
    }, [dispatch]);

    const orderExists = useMemo(() => {
        if (!repairOrder || !hasHistoryFetched) return false;
        return repairOrdersHistory.some((o) => o.roNumber === repairOrder);
    }, [repairOrder, hasHistoryFetched, repairOrdersHistory]);

    if (loading || !hasHistoryFetched) return <Loader />;

    if (repairOrder && hasHistoryFetched && !orderExists) {
        return <NoMatch />;
    }

    if (repairOrder && orderExists && !selectedRepairOrder) {
        return <Loader />;
    }

    return (
        <Layout>
            <DMSDetailContent latestRepairOrder={selectedRepairOrder} />
        </Layout>
    );
};
